import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import DashboardTopSearch from "../../../components/DashboardTopSearch/DashboardTopSearch";
import InstructorDashbordCard from "../../../components/InstructorDashbordCard/InstructorDashbordCard";
import AllCoursesForInstructor from "../../../components/AllCoursesForInstructor/AllCoursesForInstructor";
import AllStudentForInstructor from "../../../components/AllStudentForInstructor/AllStudentForInstructor";
import {
  instructorGetAllCoursesAPI,
  resetError,
} from "../../../redux/features/adminSlice";
import { instructorStatsAPI } from "../../../redux/features/intructorSlice";
import { getAllEnrolledStudentAPI } from "../../../redux/features/studentDetailSlice";
import InstructorNotification from "../../../components/Notification/InstructorNotification";

export default function InstructureDashboard() {
  const dispatch = useDispatch();
  // const { students, courses, metrics } = useSelector((state) => state.admin);
  const auth = useSelector((state) => state.auth);

  const [allStudent, setAllStudent] = useState([]);
  const [allCourses, setAllCourses] = useState([]);
  const [instructorStats, setInstructorStats] = useState({});
  const [isLoading, setIsLoading] = useState();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true)
      try {
        // Fetch students
        const allStudents = await dispatch(
          getAllEnrolledStudentAPI({ token: auth.token })
        ).unwrap();

        setAllStudent(allStudents);

        // Fetch courses
        const allCourses = await dispatch(
          instructorGetAllCoursesAPI({ token: auth.token })
        ).unwrap();
        setAllCourses(allCourses);

        const dashboardStats = await dispatch(
          instructorStatsAPI({ token: auth.token })
        ).unwrap();
        setInstructorStats(dashboardStats?.data);
      } catch (error) {
        console.error("Failed to fetch data:", error);
        setIsLoading(false)
      }finally{
        setIsLoading(false);
      }
    };

    // Call the async function
    if (auth?.token) {
      fetchData();
    } else {
      console.warn("No auth token available");
      dispatch(resetError());
    }

    return () => {};
  }, [auth?.token, dispatch]);

  return (
    <>
    {isLoading && (
        <div className="loader-container">
          <div className="dottedLoading theme-color"></div>
        </div>
      )}
      <div className="topbar mb-20 mb-lg-36">
        <div className="d-flex align-items-center justify-content-between">
          <div>
            <h3 className="ad-heading-04 fw-bold mb-8">
              Hello {auth.full_name} <span className="ad-heading-02">&#x1F44B;</span>
            </h3>
            <p className="text-gray-01 text-base fw-semibold mb-0">
              Let’s learn something new today!
            </p>
          </div>
          <div className="search-wrapper d-none d-lg-flex align-items-center gap-3">
            <DashboardTopSearch />
            <InstructorNotification />
          </div>
        </div>
      </div>
      <div className="row dashboard-card-holder">
        <InstructorDashbordCard
          title={"Active Students"}
          result={instructorStats?.allEnrolledUsersCount}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"}
          dataCard="purple"
          graphLineColor={"#353297"}
        />
        <InstructorDashbordCard
          title={"New Enrollment"}
          result={instructorStats?.newEnrollmentsIn7DaysCount}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"}
          dataCard="primary"
          graphLineColor={"#F05203"}
        />
        <InstructorDashbordCard
          title={"Student Progress"}
          result={instructorStats?.studentProgress}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"}
          dataCard="green"
          graphLineColor={"#82BD00"}
        />
        <InstructorDashbordCard
          title={"All Course"}
          result={instructorStats?.allCoursesCount}
          resultSince={"From Last 7 Days"}
          graphReport={"50%"}
          dataCard="yellow"
          graphLineColor={"#F0C20C"}
        />
      </div>
      <div className="row">
        <div className="col-12 col-xl-8 mb-24 mb-lg-32">
          <h3 className="ah-heading-05 fw-bold mb-20">All Courses</h3>
          <AllCoursesForInstructor courses={allCourses?.data} />
        </div>
        <div className="col-12 col-xl-4 mb-24 mb-lg-32">
          <h3 className="ah-heading-05 fw-bold mb-20">Students</h3>
          <AllStudentForInstructor
            detailNavigate={"/student-details"}
            students={allStudent?.data}
          />
        </div>
      </div>
    </>
  );
}
